<template>
   <div>
      <h3 class="section-title">Supporting Documents</h3>

      <p class="mart-24">
         ALL of the following documents are required. Some of these are auto-generated based on the information
         input into previous application sections. The rest you are required to upload.
      </p>

      <div v-if="!loading">
         <fieldset class="border p-2 marb-24">
            <legend class="w-auto">Generated Documents</legend>
            <p class="instructions">
               Note that some of these documents are available only after your application has been successfully
               submitted for approval.
            </p>

            <section-bar>Application Documents</section-bar>
            <div v-if="generated.length > 0">
               <div class="row doclinx" v-for="indx in generated[0].length" :key="'G' + indx">
                  <div class="col" :id="docId(generated[0][indx - 1])">
                     <a href="#"
                        @click.prevent="generateDoc(generated[0][indx - 1].documentTypeCode, generated[0][indx - 1].path)">
                        <i class="fas fa-file-pdf"></i>
                        {{ generated[0][indx - 1].documentName }}
                     </a>
                  </div>
                  <div class="col" v-if="indx <= generated[1].length" :id="docId(generated[1][indx - 1])">
                     <a href="#"
                        @click.prevent="generateDoc(generated[1][indx - 1].documentTypeCode, generated[1][indx - 1].path)">
                        <i class="fas fa-file-pdf"></i>
                        {{ generated[1][indx - 1].documentName }}
                        <span class="font-smaller text-lighter" v-if="!isVBInvitation && (isMulti && (generated[1][indx - 1].path))">
                           {{generated[1][indx - 1].carrier}}/Lvl{{generated[1][indx - 1].levelNo}}/{{generated[1][indx
                           - 1].levelName}}
                        </span>
                     </a>
                  </div>
               </div>
            </div>

            <section-bar>Agreements</section-bar>

            <div v-if="agreements.length > 0">
               <div class="row doclinx" v-for="indx in agreements[0].length" :key="'A' + indx">
                  <div class="col" :id="docId(agreements[0][indx - 1])">
                     <a href="#"
                        @click.prevent="generateDoc(agreements[0][indx - 1].documentTypeCode, agreements[0][indx - 1].path)">
                        <i class="fas fa-file-pdf"></i>
                        {{ agreements[0][indx - 1].documentName }}
                     </a>
                  </div>
                  <div class="col" v-if="indx <= agreements[1].length" :id="docId(agreements[1][indx - 1])">
                     <a href="#"
                        @click.prevent="generateDoc(agreements[1][indx - 1].documentTypeCode, agreements[1][indx - 1].path)">
                        <i class="fas fa-file-pdf"></i>
                        {{ agreements[1][indx - 1].documentName }}
                        <span class="font-smaller text-lighter" v-if="!isVBInvitation && (isMulti && (agreements[1][indx - 1].path))">
                           {{agreements[1][indx - 1].carrier}}/Lvl{{agreements[1][indx -
                           1].levelNo}}/{{agreements[1][indx - 1].levelName}}
                        </span>
                     </a>
                  </div>
               </div>
            </div>

         </fieldset>

         <fieldset class="border p-2 marb-12">
            <legend class="w-auto">Documents You Need to Upload or Send Us</legend>

            <p class="instructions">
               Missing documents are in red. Click the links to view a previously uploaded document.
               Uploads are auto-saved when an upload succeeds. All of
               the documents must be in the unencrypted PDF format and no larger than 2MB in size.
            </p>

            <div class="row marb-12">
               <div class="col-md-8 padl-48">
                  <div class="custom-control form-control-lg custom-checkbox font-smaller">
                     <input type="checkbox" class="custom-control-input" :disabled="$parent.readOnly()" id="chkFax"
                        v-model="iWillFax" @change="chg">
                     <label class="custom-control-label" for="chkFax">I will fax documents to
                        <span class="ml-corp ml-h-black">{{docFaxNumber}}</span> instead of uploading.</label>
                  </div>
               </div>
               <div class="col-md-4">
                  <div class="text-right">
                     <button type="button" class="btn ml-btn ml-white ml-bk-black ml-h-orange" data-toggle="modal"
                        data-target="#uploadModal">
                        <i class="fi-interface-upload"></i>
                        UPLOAD a DOCUMENT
                     </button>
                  </div>
               </div>
            </div>

            <section-bar>Uploaded and Faxed Documents</section-bar>

            <div v-if="uploaded.length > 0">
               <div class="row doclinx" v-for="indx in uploaded[0].length" :key="'U' + indx"
                  :id="docId(uploaded[0][indx - 1])">
                  <div class="col">
                     <a href="#" :class="{ 'missing-doc': !wasUploaded(uploaded[0][indx - 1].documentTypeCode) }"
                        @click.prevent="viewDoc(uploaded[0][indx - 1].documentTypeCode)">
                        <i class="fas fa-file-pdf"></i>
                        {{ uploaded[0][indx - 1].documentName }}
                     </a>
                  </div>
                  <div class="col" v-if="indx <= uploaded[1].length" :id="docId(uploaded[1][indx - 1])">
                     <a href="#" :class="{ 'missing-doc': !wasUploaded(uploaded[1][indx - 1].documentTypeCode) }"
                        @click.prevent="viewDoc(uploaded[1][indx - 1].documentTypeCode)">
                        <i class="fas fa-file-pdf"></i>
                        {{ uploaded[1][indx - 1].documentName }}
                     </a>
                  </div>
               </div>
            </div>

            <section-bar>Additional Documents</section-bar>
            <p>
               Use the upload button above to upload any additional documents that may assist the
               Manhattan team to approve your application.
            </p>
            <div class="row doclinx" v-for="doc in additionalDocs()" :key="doc.appUserDocumentId">
               <div class="col">
                  <a href="#" @click.prevent="openDoc(doc, 'Uploaded_Document')">
                     <i class="fas fa-file-pdf"></i>
                     {{ doc.documentPath }}
                  </a>
               </div>
            </div>

         </fieldset>

      </div>
      <div v-else>
         <i class="fas fa-spinner fa-spin ml-orange fa-lg"></i>
      </div>

      <div class="modal fade" id="uploadModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
         aria-hidden="true">
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">
                     <i class="fi-interface-upload"></i>
                     Upload Document
                  </h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                     <span aria-hidden="true">&times;</span>
                  </button>
               </div>
               <div class="modal-body">
                  <p class="instructions">
                     Choose a document type, drag one document from your computer to the drop zone, and
                     then click the upload button.
                  </p>
                  <div class="row padb-12">
                     <div class="col">
                        <select class="form-control" aria-placeholder="(Choose a Document Type)"
                           v-model="uploadingDocType">
                           <option :value="null" disabled hidden>(Choose a Document Type)</option>
                           <option v-for="dt in allDocuments" :key="dt.documentTypeCode" :value="dt">
                              {{ dt.documentName }}
                           </option>
                        </select>
                     </div>
                  </div>
                  <div class="row">
                     <div class="col">
                        <div id="drop-area" :disabled="dropDisabled">
                           <div v-if="dropDisabled" class="ml-purple">(Choose a DocumentType)</div>
                           <div v-else>
                              <div v-for="(fyl, index) in droppedFiles" :key="index" class="drop-file">
                                 <i class="fa fa-file-alt"></i>
                                 {{fyl.name}}
                                 <span @click.prevent="deleteFile(fyl.name)"><i
                                       class="fa fa-times font-smaller text-danger"></i></span>
                              </div>
                              <div v-if="droppedFiles.length==0" class="drop-msg">
                                 DRAG a DOCUMENT HERE<br />
                                 <input type="file" name="file" id="file" class="inputfile"
                                    @change="inputFileChanged" />
                                 <label for="file">or [Click to Choose a File]</label>
                              </div>
                           </div>
                        </div>

                        <div class="upload-warning"
                           v-if="uploadingDocType!=null && uploadingDocType.documentTypeCode!='DOCTYP_UNK_ADDTL_DOC' && wasUploaded(uploadingDocType.documentTypeCode)">
                           This will overwrite the current
                           <strong>{{ uploadingDocType.documentName }}</strong>
                           document that you have already uploaded. Cancel this window to abort the
                           upload.
                        </div>

                     </div>
                  </div>

                  <progress max="100" :value="uploadPercentage" v-if="uploadPercentage!=0 && uploadPercentage!=100"
                     class="progress-bar"></progress>

               </div>
               <div class="modal-footer">
                  <button type="button" class="btn ml-bk-black ml-white ml-h-orange" @click.prevent="cancelPressed">
                     <span v-if="!sending">
                        <i class="fi-interface-previous"></i>
                        CANCEL
                     </span>
                     <span v-else><i class="fas fa-spinner fa-spin"></i></span>
                  </button>
                  <button type="button" class="btn ml-bk-corp ml-white ml-h-black" @click.prevent="uploadPressed">
                     <span v-if="!sending">
                        <i class="fi-interface-upload"></i>
                        UPLOAD
                     </span>
                     <span v-else><i class="fas fa-spinner fa-spin"></i></span>
                  </button>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
   import axios from 'axios'
   import $ from 'jquery'
   import { mapGetters } from 'vuex';

   export default {
      name: "comp",
      props: {
         willFax: Boolean,
         apptType: String,
         commStmtPath: String,
         multiAppts: Array,
         remitType: String,
         appDocs: Array,
         apptId: Number
      },
      data() {
         return {
            iWillFax: this.willFax,
            docFaxNumber: process.env.VUE_APP_DOCFAXNUMBER,
            appUserId: this.$store.getters.appUser.userId,
            loading: true,
            documents: [],
            generated: [],
            agreements: [],
            uploaded: [],
            allDocuments: [],
            uploadingDocType: null,
            dropArea: null,
            droppedFiles: [],
            sending: false,
            uploadPercentage: 0,
            ismobile: false,
            maxDroppedFiles: 1,
            minDroppedFiles: 1,
            isMulti: false
         };
      },
      computed: {
         ...mapGetters(['isVBInvitation']),
         dropDisabled() {
            return this.uploadingDocType == null;
         },
      },
      async mounted() {
         this.loading = true;
         this.$parent.$parent.loadingStart();

         // Change layout if a multi-link appointment
         if (this.multiAppts != null && this.multiAppts.length > 0) {
            this.isMulti = true
         }

         try {
            // Get document requirements
            await this.$document.getRequiredDocuments(this.apptType).then((r) => {
               if (!r || r.length < 1) {
                  this.$swal(
                     "System Error",
                     "The system failed to find what documents are needed. If this problem persists please contact support.",
                     "error"
                  );
               } else {
                  this.documents = r;
                  this.generated = this.twoColumn(this.documents.generated, true);
                  this.agreements = this.twoColumn(this.documents.agreements, true);
                  this.uploaded = this.twoColumn(this.documents.uploaded, false);

                  this.allDocuments = []
                  if (this.$parent.readOnly() == null) { //they can only upload additional documents on readonly forms
                     this.allDocuments.push(...this.documents.uploaded)
                  }
                  this.allDocuments.push({
                     appointmentTypeId: 0,
                     documentName: "*** Additional Document ***",
                     documentRequirementsId: 0,
                     documentTypeCode: 'DOCTYP_UNK_ADDTL_DOC',
                     documentTypeId: 0,
                     exceptForLevel: null,
                     forLevel: null
                  });
               }
            });

            //Handle attachment drag-n-drop
            this.initializeDragNDrop()

         } finally {
            this.loading = false;
            this.$parent.$parent.loadingEnd();
         }
      },
      methods: {
         chunk(arr, len) {
            let chunks = [],
               i = 0,
               n = arr.length;

            while (i < n) {
               chunks.push(arr.slice(i, (i += len)));
            }
            return chunks;
         },
         twoColumn(arr, special) {
            // Split the documents into normal on left, special on right
            if (this.isMulti && special == true) {
               let newArr = [[], []]
               arr.forEach((itm, indx) => {
                  if (itm.documentTypeCode == "DOCTYP_COMB_APP" || itm.documentTypeCode == "DOCTYP_COMSCHED_AGREE") {
                     this.multiAppts.forEach((rec) => {
                        let ni = {
                           appointmentTypeId: itm.appointmentTypeId,
                           documentName: itm.documentName,
                           documentRequirementsId: itm.documentRequirementsId,
                           documentTypeCode: itm.documentTypeCode,
                           documentTypeId: itm.documentTypeId,
                           exceptForLevel: itm.exceptForLevel,
                           forLevel: itm.forLevel,
                           path: rec.documentPath,
                           carrier: rec.carrier,
                           levelNo: rec.levelNo,
                           levelName: rec.levelName
                        }
                        newArr[1].push(ni) //right column
                     })
                  } else {
                     newArr[0].push(itm) //left column
                  }
               })
               return newArr

               // Split the documents into 2 even columns
            } else {
               let size = arr.length / 2 + (arr.length % 2);
               return this.chunk(arr, size);
            }
         },
         docId(itm) {
            return itm.documentTypeCode.replace(/_/g, '')
         },
         generateDoc(itm, pth) {
            if (itm == "DOCTYP_DIRECT_DEPOSIT" && this.remitType != "COMRMT_TYP_DIRECT") {
               this.$swal(
                  "Document Unavailable",
                  "This Direct Deposit document is only available when Direct Deposit info has been chosen &amp; configured in the Commissions section of this application.",
                  "warning"
               );
               return
            }
            let title = "GeneratedDocument.pdf";
            if (itm == "DOCTYP_COMSCHED_AGREE" || itm == "DOCTYP_COMB_APP") {
               if (this.isMulti && pth) {
                  title = pth
               } else {
                  title = this.commStmtPath
               }
            }
            let payload = {
               AppUserId: this.appUserId,
               DownloadFileType: 2, // Generated
               Path: itm,
               Title: title,
               AppointmentId: this.apptId
            };

            this.$swal({
               title: "Download Initiated",
               html: "Please wait...",
               timer: 1000,
               timerProgressBar: true,
               showCancelButton: false,
               showConfirmButton: false,
               willOpen: () => {
                  this.$swal.showLoading();
               },
               willClose: () => { },
            });

            this.$document.apiDownload(payload).then(
               (r) => {
                  if (this.$document.errors.length > 0) {
                     this.$swal(
                        "Document Unavailable",
                        "Unfortunately we are having trouble downloading your document at this time. " + this.$document.errors[0],
                        "error"
                     );
                  }
               },
               (e) => {
                  this.$swal(
                     "Document Unavailable",
                     "Unfortunately we are having trouble downloading your document at this time. Please try again later or contact us if this problem persists.",
                     "error"
                  );
               }
            );

         },
         findReqdDoc(docType) {
            let doc = this.generated.find((d) => d.documentTypeCode == docType);
            if (doc) return doc;
            doc = this.agreements.find((d) => d.documentTypeCode == docType);
            if (doc) return doc;
            doc = this.uploaded.find((d) => d.documentTypeCode == docType);
            return doc;
         },
         async viewDoc(docType) {
            let doc = this.appDocs.find((d) => d.documentTypeCode == docType);
            let found = false;
            if (doc) {
               let typ = this.findReqdDoc(docType);
               if (typ) {
                  found = true;
                  this.openDoc(doc, typ.documentName);
               } else {
                  found = true;
                  this.openDoc(doc, "UploadedDocument");
               }
            }
            if (!found) {
               this.$swal(
                  "Document Unavailable",
                  "This document has not been uploaded or generated yet. Please try again later after uploading it or contact support if this problem persists.",
                  "warning"
               );
            }
         },
         async openDoc(doc, ttl) {
            let title = ttl.replace(/ /g, "_");
            let payload = {
               AppUserId: doc.appUserId,
               DownloadFileType: 0, // UserDoc
               Path: doc.documentPath,
               Title: title + ".pdf",
            };

            this.$swal({
               title: "Download Initiated",
               html: "Please wait...",
               timer: 1000,
               timerProgressBar: true,
               showCancelButton: false,
               showConfirmButton: false,
               willOpen: () => {
                  this.$swal.showLoading();
               },
               willClose: () => { },
            });

            this.$document.apiDownload(payload).then(
               (r) => {
                  if (this.$document.errors.length > 0) {
                     this.$swal(
                        "Document Unavailable",
                        "Unfortunately we are having trouble downloading your document at this time. Please try again later or contact us if this problem persists.",
                        "error"
                     );
                  }
               },
               (e) => {
                  this.$swal(
                     "Document Unavailable",
                     "Unfortunately we are having trouble downloading your document at this time. Please try again later or contact us if this problem persists.",
                     "error"
                  );
               }
            );
         },
         wasUploaded(docType) {
            //E & O Certificate is not required in Principal Agent appointment type.
            if (this.apptType == "APPTTYP_PRIN" && docType == "DOCTYP_EO_CERT") return true
            if (docType == "DOCTYP_DRV_LIC" || docType == "DOCTYP_AML_CERT" || docType == "DOCTYP_STATE_LIC") return true
            if (!this.appDocs || this.appDocs.length < 1) return false;
            return this.appDocs.some((d) => d.documentTypeCode == docType);
         },
         additionalDocs() {
            if (!this.appDocs || this.appDocs.length < 1) return []
            return this.appDocs.filter((d) => d.documentTypeCode == 'DOCTYP_UNK_ADDTL_DOC');
         },
         cancelPressed() {
            this.sending = false
            this.droppedFiles = []
            this.uploadingDocType = null
            $('#uploadModal').modal('hide')
         },
         async uploadPressed() {
            if (this.droppedFiles.length > this.maxDroppedFiles) {
               this.$swal(
                  "Too Many Attachments",
                  "You must select only 1 file to upload.",
                  "error"
               )
               return;
            }
            if (this.droppedFiles.length < this.minDroppedFiles) {
               this.$swal(
                  "Attachments Required",
                  "You must select 1 file to upload.",
                  "error"
               )
               return;
            }

            this.sending = true
            let formData = this.getFormData()
            this.uploadPercentage = 0
            this.$swal({
               title: "Please Wait",
               html: "<i class='fas fa-2x fa-spinner fa-spin ml-corp'></i>",
               showConfirmButton: false
            })
            let token = await this.$auth.Token()
            axios.post(process.env.VUE_APP_BASE_API_URL + "document/upload",
               formData,
               {
                  headers: {
                     'Content-Type': 'multipart/form-data',
                     'Authorization': `Bearer ${token}`
                  },
                  onUploadProgress: function (progressEvent) {
                     this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                  }.bind(this)
               }
            ).then(r => {
               this.$swal.close()
               this.sending = false
               this.$swal(
                  "Success",
                  "We have successfully received your upload.",
                  "success"
               ).then(() => {
                  // delete uploaded docs from dropzone
                  this.droppedFiles = []

                  this.$emit('update', true)
                  $('#uploadModal').modal('hide')
               })
            })
               .catch(async (e) => {
                  if ((e.status && e.status == 401) || (e.response && 401 === e.response.status)) { //UnAuthorized - kick'em out
                     await this.$swal(
                        "Session Timeout",
                        "It looks like your session on the site has timed out. Please log in again to resume...",
                        "warning"
                     )
                        .then((result) => {
                           this.$auth.logout();
                        })
                     return
                  }
                  this.$swal.close()
                  this.sending = false
                  this.$swal(
                     "System Error",
                     "Oops! Something happened along the way and your upload cannot be submitted at this time. Please try again later or contact support.",
                     "error"
                  )
               });

         },
         getFormData() {
            let formData = new FormData()
            formData.append("files", this.droppedFiles[0]); //only the first
            formData.append("appointmentId", this.apptId)
            formData.append("documentTypeCode", this.uploadingDocType.documentTypeCode)
            return formData
         },

         // Drag-N-Drop functions
         initializeDragNDrop() {
            this.dropArea = document.getElementById("drop-area");
            ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
               this.dropArea.addEventListener(eventName, this.preventDefaults, false)
            })

            this.dropArea.addEventListener("drop", this.handleDrop, false);
            ["dragenter", "dragover"].forEach((eventName) => {
               this.dropArea.addEventListener(eventName, this.highlight, false)
            });
            ["dragleave", "drop"].forEach((eventName) => {
               this.dropArea.addEventListener(eventName, this.unhighlight, false)
            })
         },
         highlight(e) {
            this.dropArea.classList.add("highlight")
         },
         unhighlight(e) {
            this.dropArea.classList.remove("highlight")
         },
         preventDefaults(e) {
            e.preventDefault()
            e.stopPropagation()
         },
         handleDrop(e) {
            // ---- Drag N Drop method of Adding Files
            this.handleFiles(e)
         },
         handleFileUpload() {
            // ---- Manual method of adding files (mobile)
            var file = this.$refs.inpfile.files[0]
            const low = file.name.toLowerCase()
            if (low.indexOf(".pdf") < 0) {
               this.$swal(
                  "Invalid File",
                  "The file you are uploading must be one of these types:<br />(PDF)",
                  "error"
               )
               return
            }
            if (file.size > 2000000) {
               this.$swal(
                  "Invalid File",
                  "The file you are uploading is too big. It must be 2MB or smaller.",
                  "error"
               )
               return
            }
            // Its good. Lets keep it
            this.droppedFiles.push(file)
         },
         handleFiles(ev) {
            // Use DataTransferItemList interface to access the file(s)
            for (var i = 0; i < ev.dataTransfer.items.length; i++) {
               // Validate the dropped file
               if (ev.dataTransfer.items[i].kind === "file") {
                  var file = ev.dataTransfer.items[i].getAsFile()
                  const low = file.name.toLowerCase()
                  if (low.indexOf(".pdf") < 0) {
                     this.$swal(
                        "Invalid File",
                        "The file you are uploading must be one of these types:<br />(PDF)",
                        "error"
                     )
                     return
                  }
                  if (file.size > 2000000) {
                     this.$swal(
                        "Invalid File",
                        "The file you are uploading is too big. It must be 2MB or smaller.",
                        "error"
                     )
                     return
                  }

                  // Its good. Lets keep it
                  this.droppedFiles.push(file)
               }
            }
         },
         inputFileChanged(ev) {
            let fileName = '';
            fileName = ev.target.value.split('\\').pop()
            let files = ev.target.files
            if (files.length < 1) {
               return
            }
            let file = files[0]
            const low = file.name.toLowerCase()
            if (low.indexOf(".pdf") < 0) {
               this.$swal(
                  "Invalid File",
                  "The file you are uploading must be one of these types:<br />(PDF)",
                  "error"
               )
               return
            }
            if (file.size > 2000000) {
               this.$swal(
                  "Invalid File",
                  "The file you are uploading is too big. It must be 2MB or smaller.",
                  "error"
               )
               return
            }

            // Its good. Lets keep it
            this.droppedFiles.push(file)
         },
         deleteFile(fyl) {
            let indx = 99;
            let df = [];
            for (var i = 0; i < this.droppedFiles.length; i++) {
               if (this.droppedFiles[i].name != fyl) {
                  df.push(this.droppedFiles[i]);
               }
            }
            this.droppedFiles = df;
         },
         chg() {
            this.$emit('update', { willFax: this.iWillFax })
         },
         blank() {

         }
      },
   };
</script>

<style scoped lang="scss">
@import "../../assets/css/colors.scss";
@import "../../assets/css/application.scss";

section-bar {
   margin-top: 24px;
}

.doclinx {
   padding: 0 24px;
   margin-bottom: 6px;
}

.doclinx a {
   font-size: 0.8em;
}

.doclinx a:hover {
   font-weight: normal;
}

.missing-doc {
   color: #cc0000;
   font-size: 0.8em;
}

.missing-doc:hover {
   color: #000;
}

#drop-area {
   background-color: #ddd;
   border: 2px dashed $corp-color;
   border-radius: 12px;
   width: 100%;
   height: 100px;
   text-align: center;
   vertical-align: middle;
   font-size: 0.8em;
   padding-top: 24px;
}

.upload-warning {
   margin-top: 12px;
   color: $corp-orange;
   font-size: 0.7em;
   font-style: italic;
}

.highlight {
   box-shadow: inset 0px 0px 6px 6px rgba(0, 167, 161, 0.9);
}

.modal-footer button {
   margin-left: 12px;
}

.down-link {
   margin-left: 6px;
}

.instructions {
   line-height: 26px;
}

/* Upload button CSS (non-dragNdrop) */
.inputfile {
   width: 0.1px;
   height: 0.1px;
   opacity: 0;
   overflow: hidden;
   position: absolute;
   z-index: -1;
}

.inputfile+label {
   display: inline-block;
   cursor: pointer;
}

.inputfile:focus+label,
.inputfile+label:hover {
   color: $corp-color;
}

.drop-msg {
   font-family: corporate-s, sans-serif !important;
}

.custom-control-label {
   padding-top: 4px;
}

.padl-48 {
   padding-left: 24px;
}

.text-lighter {
   opacity: 0.35;
}
</style>